const tracksValidationPT = {
    "trackName": {
        "required": "O nome da faixa é obrigatório",
        "length": "O nome da faixa deve ter mais de 1 e menos de 255 caracteres",
        "regexp": "O nome da faixa pode consistir apenas em letras, números, espaço e sublinhado"
    },
    "mix_name": {
        "required": "Por favor, digite o nome do mix",
        "regexp": "O nome do mix pode consistir apenas em letras, números, espaço e sublinhado"
    },
    "artistName": {
        "required": "Por favor, selecione o artista"
    },
    "artistType": {
        "required": "Por favor, selecione o tipo de artista"
    },
    "atleastOneMainArtist": {
        "required": "Pelo menos um artista deve ser principal"
    },
    "duplicateArtists": {
        "required": "Existem dois ou mais artistas com o mesmo nome."
    },
    "publisherName": {
        "required": "Por favor, selecione o editor"
    },
    "publisherAuthor": {
        "required": "Por favor, insira o nome verdadeiro e o sobrenome da pessoa."
    },
    "contributorName": {
        "required": "Por favor, selecione o colaborador"
    },
    "contributorRole": {
        "required": "Por favor, selecione o papel do colaborador"
    },
    "atleastOneComposer": {
        "required": "Pelo menos um colaborador deve ser compositor"
    },
    "atleastOneLyricist": {
        "required": "Pelo menos um colaborador deve ser letrista"
    },
    "copyright": {
        "required": "Direitos autorais são obrigatórios",
        "regexp": "Os direitos autorais podem consistir apenas em letras, números, espaço e sublinhado"
    },
    "copyrightYear": {
        "required": "O ano dos direitos autorais é obrigatório",
        "regexp": "O ano dos direitos autorais deve ser um ano válido"
    },
    "ISRC": {
        "required": "Por favor, forneça o ISRC ou marque Gerar ISRC",
        "regexp": "Por favor, insira um código ISRC válido ou deixe em branco"
    },
    "DA_ISRC": {
        "required": "Por favor, forneça o ISRC do Dolby Atmos ou marque Gerar ISRC",
        "regexp": "Por favor, insira um código ISRC válido ou deixe em branco"
    },
    "trackLanguage": {
        "required": "O idioma da faixa é obrigatório. Por favor, selecione o idioma do nome da sua faixa."
    },
    "trackVocals": {
        "required": "O vocal da faixa é obrigatório. Por favor, selecione o idioma dos seus vocais."
    },
    "trackGenre": {
        "required": "Por favor, selecione o gênero da sua faixa."
    },
    "trackSubGenre": {
        "required": "Por favor, selecione o subgênero da sua faixa"
    },
    "featuringArtistMissing": {
        "required": "A faixa deve ter o artista em destaque listado no título corretamente atribuído a um papel de artista em destaque. Por favor, corrija e envie novamente."
    }
};

export default tracksValidationPT;